import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Switch as AntdSwitch } from 'antd';
import { SwitchProps } from 'antd/lib/switch';
import clsx from 'clsx';

export type SwitchSize = 'small' | 'default' | 'medium' | undefined;
type SwitchPropsExtended = Omit<SwitchProps, 'size'> & { size?: SwitchSize; id?: string };

export const Switch = ({ size = 'default', ...rest }: SwitchPropsExtended) => {
  const customSizes = ['default', 'medium'];
  return (
    <AntdSwitch
      {...rest}
      size={size === 'medium' ? undefined : size}
      className={clsx(customSizes.includes(size) && `ant-switch-${size}`, rest.className)}
    />
  );
};
